<div class="" *ngIf="configDetails">
    <div class="custella-modal d-flex flex-column">
        <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">
                <span *ngIf="type=='requisition'">{{translate?.requisition.label.plural}}&nbsp;{{translate?.setup.users.approval.sections.sec1.plural}}</span>
                <span *ngIf="type=='consignment'">{{translate?.consignment.label.plural}}&nbsp;{{translate?.setup.users.approval.sections.sec1.plural}}</span>
            </div>
            <i class="fa-regular fa-xmark fa-lg" [pTooltip]="translate?.general.buttons.close.singular"
                tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>
        
        <div class="lv-desc flex-between">
            <div class="d-flex flex-column gap-1">
                <span class="text" id="desc_SetWorkflowNotification" ><span class="font-semiBold">Level 1</span>&nbsp;&dash;&nbsp;The Managing Group of the Zone where the bin is located</span>
                <span class="text" id="desc_SetWorkflowNotification" ><span class="font-semiBold">Level 2</span>&nbsp;&dash;&nbsp;The group that supervises or manages the Level 1 group</span>
            </div>
              <button *ngIf="type=='requisition'" class="btn-list-icon ms-2" [pTooltip]="translate?.setup.users.approval.sections.sec4.singular" tooltipPosition="bottom"  (click)="openModal('howApprovalWorksRequisition', null)">
                 <i class="fa-regular fa-question"></i>
              </button>
              <button *ngIf="type=='consignment'" class="btn-list-icon ms-2" [pTooltip]="translate?.setup.users.approval.sections.sec4.singular" tooltipPosition="bottom"  (click)="openModal('howApprovalWorksConsignment', null)">
                 <i class="fa-regular fa-question"></i>
              </button>
        </div>

        <div class="custella-modal-body p-0">
            <div class="custella-form-container box-none m-0">
                <div class="custella-form-container-title-two-grey ps-4">
                      <span class="text-13 font-semiBold d-block">{{translate?.setup.users.approval.sections.sec2.plural}}</span>
                </div>
                <div class="custella-form-container-title-two-grey-two ps-4">
                    <span class="text-12 font-medium d-block" *ngIf="type=='requisition'">{{translate?.setup.users.approval.messages.selectWhoNeedsToApprove}}</span>
                    <span class="text-12 font-medium d-block" *ngIf="type=='consignment'">{{translate?.setup.users.approval.messages.selectWhoNeedsToApproveConsignment}}</span>
                </div>
                <div class="custella-form-container-content my-3">
                    <div class="custella-content-row pe-0">
                        <div class="flex-align-center me-2 gap-2">
                            <p-checkbox class="my-2" [binary]="true" [(ngModel)]="configDetails.requisitionRequesterManagingGroupApproves"></p-checkbox>
                            <span class="text-12">{{translate?.setup.users.approval.fields.requestorManagingGroup.singular}}</span>
                        </div>
                    </div>
                    <div class="custella-content-row pe-0">
                        <div class="flex-align-center me-2 gap-2">
                            <p-checkbox class="my-2" [binary]="true" [(ngModel)]="configDetails.requisitionReceiverLevel1GroupApproves" (onChange)="setData()"></p-checkbox>
                          <span class="text-12">{{translate?.setup.users.approval.fields.receiverLevelOneGroup.plural}}</span>
                        </div>
                    </div>
                    <div class="custella-content-row pe-0">
                        <div class="flex-align-center me-2 gap-2">
                            <p-checkbox class="my-2" [binary]="true" [(ngModel)]="configDetails.requisitionReceiverLevel2GroupApproves" (onChange)="setData()"></p-checkbox>
                            <span class="text-12">{{translate?.setup.users.approval.fields.receiverLevelTwoGroup.plural}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="configDetails.requisitionReceiverLevel1GroupApproves && configDetails.requisitionReceiverLevel2GroupApproves">
                    <div class="custella-form-container-title-two-grey ps-4">
                        <span class="text-13 font-semiBold d-block">{{translate?.setup.users.approval.sections.sec3.plural}}</span>
                    </div>
                    <div class="custella-form-container-title-two-grey-two ps-4">
                        <span class="text-12 font-medium d-block">{{translate?.setup.users.approval.messages.defineSequenceApprovalOccur}}</span>
                    </div>
                    <div class="custella-form-container-content my-3">
                        <div class="custella-content-row pe-0">
                            <div class="flex-align-center me-2 gap-2">
                                <p-radioButton name="approvalOrder" 
                                [(ngModel)]="approvalOrder" 
                                value="requisitionLevel1MustApproveBeforeLevel2"
                                (onClick)="radioChange()" styleClass="my-2"></p-radioButton>
                                 <span class="text-12">{{translate?.setup.users.approval.fields.levelOneMustApprove.plural}}</span>
                            </div>
                        </div>
                        <div class="custella-content-row pe-0">
                            <div class="flex-align-center me-2 gap-2">
                                <p-radioButton name="approvalOrder" 
                                [(ngModel)]="approvalOrder" 
                                value="requisitionLevel2MustApproveBeforeLevel1"
                                (onClick)="radioChange()" styleClass="my-2" ></p-radioButton>
                                
                                <span class="text-12">{{translate?.setup.users.approval.fields.levelTwoMustApprove.plural}}</span>
                            </div>
                        </div>
                        <div class="custella-content-row pe-0">
                            <div class="flex-align-center me-2 gap-2">
                                <p-radioButton name="approvalOrder" 
                                [(ngModel)]="approvalOrder" 
                                value="requisitionApprovalsCanBeDoneInAnyOrder"
                                (onClick)="radioChange()" styleClass="my-2"></p-radioButton>
                                
                                <span class="text-12">{{translate?.setup.users.approval.fields.approvalDoneAnyOrder.plural}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="custella-modal-footer flex-between">
            <div class="flex-align-center gap-1">
                    <span class="text-12 font-semiBold">{{translate?.note.label.singular}}:</span>       
                    <span class="text-12" *ngIf="type=='requisition'">{{translate?.setup.users.approval.messages.theseSettingsDetermineOverallFlow}}</span>           
                    <span class="text-12" *ngIf="type=='consignment'">{{translate?.setup.users.approval.messages.theseSettingsDetermineOverallFlowConsignment}}</span>           
            </div>        

            <div class="flex-align-center justify-content-end">
                <button type="button"class="custella-btn-white text-12 ms-2" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                <p-button type="button" [label]="translate?.general.buttons.save.singular" styleClass="ms-2 h-32" (onClick)="saveConsignmentApproval()"></p-button>
            </div>
        </div>
    </div>
</div>